module.exports = __webpack_public_path__ + "assets/img/icon-badge-50129064.png";